export default "__VITE_ASSET__Cl$J8eIn__"